import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "AND on Specific Clause",
  order: 40,
};
